import { makeStyles } from '@mui/styles'
import MaterialUITooltip from '@mui/material/Tooltip'
import PropTypes from 'prop-types'

import { color } from 'styles/colors'

const propTypes = {
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  disableFocusListener: PropTypes.bool,
  showArrow: PropTypes.bool,
  placement: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}

const defaultProps = {
  className: '',
  title: '',
  disableFocusListener: false,
  showArrow: true
}

const Tooltip = ({ className, title, placement, disableFocusListener, children, showArrow }) => {
  const classes = makeStyles(() => (S))()

  return (
    <MaterialUITooltip
      className={className}
      disableFocusListener={disableFocusListener}
      disableInteractive
      {...{ placement, title }}
      enterDelay={500}
      leaveDelay={50}
      classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
      arrow={showArrow}
    >
      {children}
    </MaterialUITooltip>
  )
}

Tooltip.propTypes = propTypes
Tooltip.defaultProps = defaultProps

export default Tooltip

const S = {
  tooltip: {
    fontSize: '1rem',
    maxWidth: '340px',
    color: color('tooltipText'),
    backgroundColor: color('paneBackground'),
    border: `2px solid ${color('tooltipBorder')}`,
    boxShadow: `
      2px 2px 2px -2px ${color('tooltipBorder')},
      2px 2px 2px -2px ${color('tooltipBorder')},
      -2px 2px 2px -2px ${color('tooltipBorder')}
    `
  },
  arrow: {
    fontSize: '25px',
    color: color('tooltipBorder')
  }
}
